export enum RequestState {
	IDLE,
	Requested,
	Received,
}

export enum ButtonType {
	Disabled,
	Saving,
	Saved,
	Enabled,
}

export enum Language {
	English = "en",
	French = "fr",
}

export enum CardType {
	AVAILABLE = "Available",
	COMING_SOON = "Coming soon",
	OFF_SEASON = "Off-Season",
	HIDDEN = "Hidden",
}

export enum ShareType {
	FB,
	TW,
	MOBILE,
}
